import InputMask from "@amzn/meridian/input/mask";
import {ADTA_ASSET_TYPE, ASL_ASSET_TYPE} from "./Constants";

export const MAC_MASK = new InputMask(
    '^^:^^:^^:^^:^^:^^',
    {
        formatChars: {
            '^': '[0-9a-fA-F]'
        }
    }
);
export const PORT_MASK = new InputMask(
    '^^^^',
    {
        formatChars: {
            '^': '[0-9]'
        }
    }
);
export const DIVERT_CODE_MASK = new InputMask(
    '^^',
    {
        formatChars: {
            '^': '[0-9]'
        }
    }
);

export const PROTOCOLS = {
    ADTA: ['sort', 'sort-2021-v1'],
    ASL: ['slam', 'slam-2021-v1']
}

export const INSTALLATION_TYPES = ['aisle', 'miss', 'cluster', 'column', 'ov'];

export const PATTERNS = {
    NAME: /^[A-Za-z0-9 -]{1,50}$/,
    MAC: /^([0-9a-f]{2}[:]){5}([0-9a-f]{2})$/,
    BAY_ID: /^[0-9]{1,8}$/,
    DEVICE_ID: /^[A-Z0-9]{1,4}$/,
    PORT: /^([1-9][0-9]{0,3}|[1-5][0-9]{4}|6[0-4][0-9]{3}|65[0-4][0-9]{2}|655[0-2][0-9]|6553[0-5])$/,
    CLUSTERS: /^([A-Z]|(([A-Z];)*[A-Z]))$/,
    LOCATION: /^([A-Z],[0-9]{1,3})(;[A-Z],[0-9]{1,3})*$/,
    SCANNABLE: /^([A-Za-z_0-9]{11,})(;[A-Za-z_0-9]{11,})*$/,
    SORT_ZONE: /(([A-Z])(\d*)-(\d)([A-Z]))|(([A-Z])-(\d*).(\d)([A-Z]))/,
    DIVERT_CODE: /^[1-9][0-9]$/,
    LONG_STRING: /^[A-Za-z0-9 '_]{1,200}/,
    DATE: /\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}/
}

export const ZERO_TO_255
    = "(\\d{1,2}|(0|1)\\"
    + "d{2}|2[0-4]\\d|25[0-5])";

// Regex for a digit from 0 to 255 and
// followed by a dot, repeat 4 times.
// this is the regex to validate an IP address.
export const IP_ADDRESS_PATTERN
    = new RegExp("^" + ZERO_TO_255 + "\\."
    + ZERO_TO_255 + "\\."
    + ZERO_TO_255 + "\\."
    + ZERO_TO_255 + "$");

export function isValidEntry(entry, regex) {
    return regex.test(entry);
}

export function areAllInputsFulfilled(stateValues) {
    return stateValues.name && stateValues.mac && stateValues.deviceType && stateValues.ip && stateValues.port && stateValues.deviceConfig.id;
}

export function areAllInputsFulfilledForMonitoring(stateValues) {
    return stateValues.startTime && stateValues.endTime && stateValues.reason;
}

export function areAllInputsFulfilledForConfig(config, assetType) {
    if (assetType === ADTA_ASSET_TYPE) {
        return config.bayId && config.installation.type && config.installation.locations;
    } else if (assetType === ASL_ASSET_TYPE)
        return config.divertCode && config.clusters;
}

export function areAllInputsFulfilledForTestPackage(sorterTestPackage) {
        return sorterTestPackage.scannables && sorterTestPackage.sortZone;
}

export function validateNewAslDevice(stateValues) {
    return areAllInputsFulfilled(stateValues) &&
        isValidEntry(stateValues.ip, IP_ADDRESS_PATTERN) &&
        isValidEntry(stateValues.mac, PATTERNS.MAC) &&
        PROTOCOLS.ASL.includes(stateValues.deviceType) &&
        isValidEntry(stateValues.port, PATTERNS.PORT) &&
        isValidEntry(stateValues.deviceConfig.id, PATTERNS.DEVICE_ID) &&
        isValidEntry(stateValues.name, PATTERNS.NAME);
}

export function validateNewAdtaDevice(stateValues) {
    return areAllInputsFulfilled(stateValues) &&
        isValidEntry(stateValues.ip, IP_ADDRESS_PATTERN) &&
        isValidEntry(stateValues.mac, PATTERNS.MAC) &&
        PROTOCOLS.ADTA.includes(stateValues.deviceType) &&
        isValidEntry(stateValues.port, PATTERNS.PORT) &&
        isValidEntry(stateValues.deviceConfig.id, PATTERNS.DEVICE_ID) &&
        isValidEntry(stateValues.name, PATTERNS.NAME);
}

export function checkModalValidationsForMonitoring(stateValues) {
    return areAllInputsFulfilledForMonitoring(stateValues) &&
        isValidEntry(stateValues.reason, PATTERNS.LONG_STRING)
}

export function checkModalValidationsForConfig(stateValues, mac, assetType) {
    if (assetType === ADTA_ASSET_TYPE) {
        return areAllInputsFulfilledForConfig(stateValues, assetType) &&
            isValidEntry(stateValues.bayId, PATTERNS.BAY_ID) &&
            isValidEntry(stateValues.installation.locations, PATTERNS.LOCATION) &&
            INSTALLATION_TYPES.includes(stateValues.installation.type) &&
            isValidEntry(mac, PATTERNS.MAC);
    } else if (assetType === ASL_ASSET_TYPE) {
        return areAllInputsFulfilledForConfig(stateValues, assetType) &&
            isValidEntry(stateValues.divertCode, PATTERNS.DIVERT_CODE) &&
            isValidEntry(stateValues.clusters, PATTERNS.CLUSTERS) &&
            isValidEntry(mac, PATTERNS.MAC);
    }
}

export function checkModalValidationsForTestPackage(stateValues) {
        return areAllInputsFulfilledForTestPackage(stateValues) &&
            isValidEntry(stateValues.scannables, PATTERNS.SCANNABLE) &&
            isValidEntry(stateValues.sortZone, PATTERNS.SORT_ZONE)
}



// WEBPACK FOOTER //
// ./src/components/util/Validations.js